<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        v-on="on"
      >
        Copy Tax Relief
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Tax Relief replication"
      text="Copy tax relief from a past year"
      class="mb-0"
    > 
      <v-container
        v-if="dialog"
        class="pb-0"
      >
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="baseYear"
              v-validate="'required'"
              label="Base Year"
              :items="years"
              item-text="value"
              item-value="id"
              outlined
              :error-messages="errors.collect('baseYear')"
              data-vv-name="baseYear" 
              data-vv-as="base year"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="destinationYear"
              v-validate="'required'"
              label="Destination Year"
              data-vv-name="destinationYear"
              data-vv-as="destination year"  
              :error-messages="errors.collect('destinationYear')"
              :items="validYears"
              item-text="name"
              outlined
            />
          </v-col>
        </v-row>
      </v-container>       
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="white--text px-10"       
          @click="submitForm"
        >
          Copy
        </v-btn>
      </v-card-actions>
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {     
      years: {
        type: Array,
        required: true,
      }, 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        baseYear: parseInt(this.$moment().format('YYYY')),
        destinationYear: null,
      }
    },
    computed: {
      validYears () {
        if (this.baseYear === (this.$moment().year())) {
          return [
            this.$moment().year() + 1,
          ]
        } else {
          return [
            this.$moment().year(),
            this.$moment().year() + 1,
          ]
        }
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },

    methods: { 
      prepareFormData () {
        return {
          baseYear: this.baseYear,
          destinationYear: this.destinationYear,
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.setProgressing(true)
    
            this.$api.taxReliefs().createMany(this.prepareFormData())
              .then((res) => {
                if (res.status === 200) {
                  this.$snack({ message: 'Tax relief successfully copied' })
                  this.$validator.pause()

                  this.setDialog(false)
                  this.$emit('created')                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }

</style>
